import React, { PropTypes } from 'react';
import { equals, call, cond, prop, either, ifElse, always } from 'ramda';
import { FontIcon, ListItem } from 'material-ui';
import GenericPageLayout from '../generic-page-layout';
import GenericTableRow from '../generic-table-row';
import {
  accomInfo,
  buyerInfo,
  dmoInfo,
  marketingRep,
  publicRelations,
  techProviders,
  industryMemberOrganization,
  mediaProvider,
  otherProvider,
} from './acct-creation-text';

const AcctCreationReasonContainer = props => {
  const {
    acctCreationReason,
    goToSignUpForm,
    dispatchedUpdateProps,
    step,
    numOfIndicatorDots,
    selectedCompanyType,
    goToAccomNonAccomPage,
    backButtonFunc,
    companyTypeChecked,
  } = props;

  const selectAcctCreationReason = selected => dispatchedUpdateProps({ acctCreationReason: selected });

  const otherCheck = call(cond([
    [equals('Marketing Representation Agency'), always(marketingRep)],
    [equals('Public Relations Agency'), always(publicRelations)],
    [equals('Technology Provider'), always(techProviders)],
    [equals('Industry Member Organization/Association'), always(industryMemberOrganization)],
    [equals('Media'), always(mediaProvider)],
    [equals('Other Provider'), always(otherProvider)],
  ]), prop(0, companyTypeChecked));

  const tableInfo = call(cond([
    [either(equals('Accommodation'), equals('Non-Accommodation')), () => accomInfo],
    [equals('buyer'), () => buyerInfo],
    [equals('dmo'), () => dmoInfo],
    [equals('other'), () => otherCheck],
  ]), selectedCompanyType);

  const tableBody = tableInfo.map((reason, index) => {
    return (
      <GenericTableRow
        key={index}
        leftIcon={<FontIcon className={reason.leftIcon} style={{ color: equals(acctCreationReason, reason.creationReason) ? 'rgb(0, 188, 212)' : '#757575', fontSize: '33px' }} />}
        leftIconStyle={{ borderLeft: '1px solid #eeeeee', borderBottom: '1px solid #eeeeee', borderTop: '1px solid #eeeeee', width: '15%', textAlign: 'center' }}
        middleInfo={<ListItem
          primaryText={
            <div>
              <p style={{ fontSize: '16px', color: 'rgba(0, 0, 0, 0.54)' }}>{reason.title}</p>
              {reason.desc.map((desc, i) => {
                return (
                  <div key={i} style={{ color: '#000000', fontSize: '14px', lineHeight: '1.5' }}>
                    {desc}
                  </div>
                );
              })}
            </div>
          }
          onTouchTap={() => selectAcctCreationReason(reason.creationReason)}
          className="remove-hover-color"
        />}
        middleInfoStyle={{ padding: '0px', fontSize: '16px', borderBottom: '1px solid #eeeeee', borderTop: '1px solid #eeeeee', whiteSpace: 'break-word' }}
        rightIcon={<FontIcon
          onTouchTap={() => selectAcctCreationReason(reason.creationReason)}
          className="tc-icon-check_circle"
          color={equals(acctCreationReason, reason.creationReason) ? 'rgb(0, 188, 212)' : '#eeeeee'}
          style={{ cursor: 'pointer' }}
        />}
        rightIconStyle={{ borderRight: '1px solid #eeeeee', borderBottom: '1px solid #eeeeee', borderTop: '1px solid #eeeeee', width: '12%', textAlign: 'center' }}
        outerTableStyle={{ height: '108px' }}
        thirdColumn
      />
    );
  });

  return (
    <GenericPageLayout
      pageDesc={'So we can point you in the right direction as you get started, please let us know your primary reason for creating an account.'}
      boldedTableDesc={'Please select your primary reason for creating an account.'}
      dispatchedUpdateProps={dispatchedUpdateProps}
      numOfIndicatorDots={numOfIndicatorDots}
      step={step}
      tableInfo={tableBody}
      onNextClick={
        call(ifElse(
          either(equals('Accommodation'), equals('Non-Accommodation')),
            () => goToAccomNonAccomPage,
          () => goToSignUpForm
        ), selectedCompanyType)
      }
      nextButtonDisabled={equals(acctCreationReason, '')}
      backButtonFunc={backButtonFunc}
    />
  );
};

AcctCreationReasonContainer.propTypes = {
  selectAcctCreationReason: PropTypes.func,
  acctCreationReason: PropTypes.string,
  goToSignUpForm: PropTypes.func,
  dispatchedUpdateProps: PropTypes.func,
  step: PropTypes.number,
  numOfIndicatorDots: PropTypes.number,
  selectedCompanyType: PropTypes.string,
  goToAccomNonAccomPage: PropTypes.func,
  backButtonFunc: PropTypes.func,
  companyTypeChecked: PropTypes.array,
};

export default AcctCreationReasonContainer;



// WEBPACK FOOTER //
// ./src/app/components/signup/acct-creation-reason/acct-creation-reason-container.jsx